<div class="modal fade" id="transferModal" tabindex="-1"  role="dialog" aria-labelledby="sendModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content" *ngIf="!!case">
        <!-- Header -->
        <div appDraggableModal [position]="'fixed'" class="modal-header">
          <h5 class="modal-title">
            <!-- Standard Case -->
            <span *ngIf="caseType == 'case' && !reject">{{ 'Standard.CreateCase' | translate }}</span>
            <!-- From Partner -->
            <span *ngIf="caseType == 'partnerCase' && !reject">{{ 'Standard.PartnerCase' | translate }}</span>
            <span *ngIf="caseType == 'partnerOffer' && !reject">{{ ('Buttons.AcceptReject' | translate)}} {{ (('Standard.Offer' | translate) | lowercase) }}</span>
            <!-- Email -->
            <span *ngIf="caseType == 'email' && !reject">{{ 'Standard.Email' | translate }}</span>
            <!-- Reject Case -->
            <span *ngIf="!!reject">{{ 'Standard.RejectCase' | translate }}</span>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="reset();openModal = false"><span aria-hidden="true" class="close-btn">&times;</span></button>
        </div>

        <!-- Standard Body -->
        <div class="modal-body" *ngIf="!reject">
            <!-- Customer Address -->
            <div class="row">
                <div class="col-12">
                  <app-customer-address [step]="customerStep"
                  [customerId]="case.customer?.id"
                  [deliveryId]="case.delivery?.id"
                  [contactId]="case.contact?.id"
                  [notification]="case.caseNotificationAddress"
                  [newCaseCustomer]="partnerCase"
                  [do]="customerAction"
                  (com)="documentAddressChange($event)"
                  (update)="documentAddressChange($event)">
                  </app-customer-address> 
                </div>
                <!-- Address Control Buttons -->
                <div class="col-12 flex-between mb-3">
                  <button class="btn btn-sm btn-primary" *ngIf="customerStep != 'final'" (click)="customerStep = 'final'">{{ 'Buttons.Back' | translate }}</button>
                  <div *ngIf="!!case.caseId">
                    <button class="btn btn-sm btn-success" *ngIf="customerStep == 'editCustomer'" (click)="customerStep = 'chooseCustomer'">{{ 'Buttons.ChangeCustomer' | translate }}</button>
                    <button class="btn btn-sm btn-success" *ngIf="customerStep == 'editCustomer'" (click)="customerStep = 'final'; customerAction = 'editCustomer'">{{ 'Buttons.Save' | translate }}</button>
                    <button class="btn btn-sm btn-success" *ngIf="customerStep == 'chooseDelivery'" (click)="customerStep = 'final'; customerAction = 'chooseDelivery'">{{ 'Standard.Choose' | translate }}</button>
                    <button class="btn btn-sm btn-success" *ngIf="customerStep == 'chooseContact'" (click)="customerStep = 'final'; customerAction = 'chooseContact'">{{ 'Standard.Choose' | translate }}</button>
                    <button class="btn btn-sm btn-success" *ngIf="customerStep == 'chooseCustomer'" (click)="customerStep = 'final'; customerAction = 'chooseCustomer'">{{ 'Standard.Choose' | translate }}</button>
                  </div>
                  <div *ngIf="!case.caseId">
                    <button class="btn btn-sm btn-success" *ngIf="customerStep == 'final'" (click)="customerStep = 'chooseCustomer'">{{ 'Buttons.ConnectToExistingCustomer' | translate }}</button>
                    <button class="btn btn-sm btn-success" *ngIf="customerStep == 'editCustomer'" (click)="customerStep = 'final'; customerAction = 'back'">{{ 'Buttons.Save' | translate }}</button>
                    <button class="btn btn-sm btn-success" *ngIf="customerStep == 'chooseDelivery'" (click)="customerStep = 'final'; customerAction = 'back'">{{ 'Standard.Choose' | translate }}</button>
                    <button class="btn btn-sm btn-success" *ngIf="customerStep == 'chooseContact'" (click)="customerStep = 'final'; customerAction = 'back'">{{ 'Standard.Choose' | translate }}</button>
                    <button class="btn btn-sm btn-success" *ngIf="customerStep == 'chooseCustomer'" (click)="customerStep = 'final'; customerAction = 'back'">{{ 'Standard.Choose' | translate }}</button>
                  </div>
                </div>
            </div>
            <div class="row">
              <div class="col-12 mt-3">
                <h3>{{ 'Shop.TaskDetails' | translate }}</h3>
              </div>
              <div class="col-6">
                <!-- Responsible -->
                <div class="dataItem">
                  <label class="dataItem-label">{{ 'Standard.Responsible' | translate }} <span style="color:red">*</span></label>
                  <select class="form-control form-control-sm" [(ngModel)]="case.responsible" (change)="f.changeResponsible(case.caseId, case.responsible)">
                    <option [ngValue]="null">{{ 'Standard.NoneChosen' | translate }}</option>
                    <option *ngFor="let x of f.responsibles" [value]="x.key">{{ x.value }}</option>
                  </select>
                </div>
                <!-- Department -->
                <div class="dataItem">
                  <label class="dataItem-label">{{ 'Standard.Department' | translate }}</label>
                  <select class="form-control form-control-sm form-control-erp" [(ngModel)]="data.eDimensionDepartmentId">
                    <option [ngValue]="null">{{ 'Standard.Choose' | translate }}</option>
                    <option *ngFor="let x of departments" value="{{ x.id }}">{{ x.name }}</option>
                  </select>
                </div>
                <!-- Requisition -->
                <div class="dataItem">
                  <label class="dataItem-label">{{ 'Standard.Requisition' | translate }}</label>
                  <input type="text" class="form-control form-control-sm" [(ngModel)]="case.requisitionNumber" (change)="editCase()">
                </div>
                <!-- Our Reference -->
                <div class="dataItem">
                  <label class="dataItem-label">{{ 'Standard.Reference' | translate }}</label>
                  <input type="text" class="form-control form-control-sm"[(ngModel)]="case.reference" (change)="editCase()">
                </div>
                <!-- Title -->
                <div class="dataItem">
                  <label class="dataItem-label">{{ 'Standard.Title' | translate }}</label>
                  <input type="text" class="form-control form-control-sm" id="title" [(ngModel)]="case.title" (change)="editCase()">
                </div>
              </div>
              <div class="col-6">
                <!-- Order Group -->
                <div class="dataItem">
                  <label class="dataItem-label">{{ 'Standard.OrderGroup' | translate }}</label>
                  <select class="form-control form-control-sm form-control-erp" [(ngModel)]="data.eOrderGroupId">
                    <option [ngValue]="null">{{'Standard.Choose' | translate }}</option>
                    <option *ngFor="let x of orderGroups" value="{{ x.id }}">{{ x.name }}</option>
                  </select>
                </div>
                <!-- Carrier -->
                <div class="dataItem">
                  <label class="dataItem-label">{{ 'Standard.Carrier' | translate }}</label>
                  <select class="form-control form-control-sm form-control-erp" [(ngModel)]="data.eDimensionCarrierId">
                    <option [ngValue]="null">{{ 'Standard.Choose' | translate }}</option>
                    <option *ngFor="let x of dimensionCarrier" [ngValue]="x.id">{{ x.name }}</option>
                  </select>
                </div>
                <!-- Price Group -->
                <div class="dataItem">
                  <label class="dataItem-label">{{ 'Standard.PriceGroup' | translate }}</label>
                  <select class="form-control form-control-sm form-control-erp" [(ngModel)]="data.ePriceGroupId">
                    <option [ngValue]="null">{{ 'Standard.Choose' | translate }}</option>
                    <option *ngFor="let x of priceGroups" [ngValue]="x.id">{{ x.name }}</option>
                  </select>
                </div>
                <!-- Profit Group -->
                <div class="dataItem">
                  <label class="dataItem-label">{{ 'Standard.ProfitGroup' | translate }}</label>
                  <select class="form-control form-control-sm form-control-erp" [(ngModel)]="data.eProfitGroupId">
                    <option [ngValue]="null">{{ 'Standard.Choose' | translate }}</option>
                    <option [ngValue]="x.id" *ngFor="let x of profitGroups">{{ x.name }}</option>
                  </select>
                </div>
                <!-- Purpose -->
                <div class="dataItem">
                  <label class="dataItem-label">{{ 'Word.Purpose' | translate }}</label>
                  <select class="form-control form-control-sm form-control-erp" [(ngModel)]="data.eDimensionPurposeId">
                    <option [ngValue]="null">{{ 'Standard.Choose' | translate }}</option>
                    <option [ngValue]="x.id" *ngFor="let x of purposes">{{ x.name }}</option>
                  </select>
                </div>
                <!-- Project Type -->
                <div class="dataItem">
                  <label class="dataItem-label">{{ 'Standard.ProjectType' | translate }}</label>
                  <select class="form-control form-control-sm form-control-erp" [(ngModel)]="data.eProjectType">
                    <option [ngValue]="null">{{ 'Standard.Choose' | translate }}</option>
                    <option [ngValue]="'enterprise'">Enterprise</option>
                    <option [ngValue]="'spjæld'">Spjæld</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 mt-2">
                <label>{{ 'Standard.Description' | translate }}</label>
                <textarea class="form-control" id="description" rows="3" [(ngModel)]="case.description" (change)="editCase()"></textarea>
                <span class="red ml-1" *ngIf="case.description == null || case.description == ''">{{ 'Standard.MissingDescription' | translate }}</span>
              </div>
              <div class="col-12 mt-2">
                <label>{{ 'Standard.InternalRemark' | translate }}</label>
                <textarea id="internalNote" rows="3" class="form-control form-control-sm" [(ngModel)]="case.internalNote" (change)="editCase()"></textarea>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12">
                <case-task-create [caseId]="case.caseId" [customerId]="case.customer.id"></case-task-create>
              </div>
            </div>
        </div>

        <!-- Rejection Body -->
        <div class="modal-body" *ngIf="!!reject">
          <h3 *ngIf="!case.caseId">{{ 'Standard.RejectConfirmationText' | translate }}?</h3>
          <h3 *ngIf="!!case.caseId">{{ 'Standard.CancelConfirmationText' | translate }}?</h3>
        </div>

        <!-- Standard Footer -->
        <div class="modal-footer flex-between" *ngIf="!reject">
          <!-- Left -->
          <div class="d-flex">
            <button hidden id="transferCaseCloseModalBtn" data-dismiss="modal"></button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="openModal = false" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
            <button class="btn btn-sm btn-primary ml-2" (click)="reject = false" *ngIf="!!reject">{{ 'Buttons.Back' | translate }}</button>
          </div>
          <!-- Middle -->
          <div class="d-flex justify-content-center" *ngIf="!reject">
            <!-- Case Denial -->
            <button type="button" class="btn btn-sm btn-danger mr-3" (click)="reject = !reject" *ngIf="!case.transferId && !!case.caseId">{{ 'Buttons.Cancel' | translate }}</button>
            <button type="button" class="btn btn-sm btn-danger" (click)="reject = !reject" *ngIf="!!case.transferId && !case.caseId">{{ 'Buttons.Reject' | translate }}</button>
            <!-- Go to Case -->
            <button type="button" class="btn btn-sm btn-success" (click)="goToCase()" data-dismiss="modal" *ngIf="!!case.caseId">{{ !!partnerCase && partnerCase.isOfferRequest ? ('Buttons.GoToOffer' | translate) : ('Buttons.GoToCase' | translate) }}</button>
          </div>
          <!-- Acceptable Right -->
          <div class="d-flex justify-content-end">
            <!-- Standard -->
            <button class="btn btn-sm btn-EKomplet" *ngIf="caseType == 'case'" (click)="accept(true)" data-dismiss="modal" [disabled]="!case.responsible" [title]="!case.responsible ? ( ('Word.Missing' | translate) + ': ' + ('Standard.Responsible' | translate) ) : (('Buttons.Accept' | translate) + ' ' + ('Standard.AndTransferTo' | translate) + ' E-komplet' )">{{ 'Buttons.Accept' | translate }} {{ 'Standard.SendTo' | translate }} E-Komplet</button>
            <button class="btn btn-sm btn-success" *ngIf="caseType == 'partnerCase'" (click)="accept(false)" data-dismiss="modal">{{ 'Buttons.Accept' | translate }}</button>
            <button class="btn btn-sm btn-EKomplet ml-2" *ngIf="caseType == 'partnerCase'" (click)="accept(true)" data-dismiss="modal" [disabled]="!case.responsible" [title]="!case.responsible ? ( ('Word.Missing' | translate) + ': ' + ('Standard.Responsible' | translate) ) : (('Buttons.Accept' | translate) + ' ' + ('Standard.AndTransferTo' | translate) + ' E-komplet' )">{{ 'Buttons.Accept' | translate }} {{ 'Standard.AndTransferTo' | translate }} E-Komplet</button>
            <!-- Accept Offer -->
            <button class="btn btn-sm btn-success" *ngIf="caseType == 'partnerOffer'" (click)="accept(false)">{{ 'Buttons.AcceptOffer' | translate }}</button>
            <!-- Send as Message on Case -->
            <div *ngIf="caseType == 'email'">
              <case-search (case)="addMessageToCase($event)" [small]="true" [default]="'Transfer.AddMessageToCase'"></case-search>
            </div>
            <!-- Create Case From Email -->
            <button class="btn btn-sm btn-success" *ngIf="caseType == 'email'" (click)="accept(false)">{{ 'Buttons.Accept' | translate }}</button>
            <button class="btn btn-sm btn-EKomplet ml-2" *ngIf="caseType == 'email'" (click)="accept(true)" [disabled]="!case.responsible" [title]="!case.responsible ? ( ('Word.Missing' | translate) + ': ' + ('Standard.Responsible' | translate) ) : (('Buttons.Accept' | translate) + ' ' + ('Standard.AndTransferTo' | translate) + ' E-komplet' )">{{ 'Buttons.Accept' | translate }} {{ 'Standard.AndTransferTo' | translate }} E-Komplet</button>
          </div>
        </div>

        <!-- Rejectable Footer -->
        <div class="modal-footer flex-between" *ngIf="!!reject">
          <!-- Left -->
          <div class="d-flex">
            <button hidden id="transferCaseCloseModalBtn" data-dismiss="modal"></button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="openModal = false" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
            <button class="btn btn-sm btn-primary ml-2" (click)="reject = false" *ngIf="!!reject">{{ 'Buttons.Back' | translate }}</button>
          </div>
          <!-- Right -->
          <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-danger" (click)="cancelCase()" data-dismiss="modal" *ngIf="!!case.caseId">{{ 'Buttons.Cancel' | translate }}</button>
            <button type="button" class="btn btn-danger" (click)="rejectCase()" data-dismiss="modal" *ngIf="!case.caseId">{{ 'Buttons.Reject' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
</div>
<button hidden id="transferCaseModalOpener" #transferCaseModalOpener data-toggle="modal" data-target="#transferModal"></button>